import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e80cc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-weight":"600"} }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "completion2-option-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "completion2-option-details" }
const _hoisted_6 = { class: "completion2-option-header" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "completion2-option-content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "completion2-option-footer" }
const _hoisted_11 = { class: "completion2-option-actions" }
const _hoisted_12 = { class: "completion2-option-price" }
const _hoisted_13 = { class: "no-mb" }
const _hoisted_14 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kies eerst bovenstaande opties. Werk van boven naar beneden.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, [
  /*#__PURE__*/_createTextVNode("Heeft u bij alle bovenstaande onderdelen een optie gekozen en ziet u hier geen opties?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Dan zijn er in deze categorie geen opties beschikbaar in combinatie met de hierboven gekozen opties.")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Optie", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Afbeelding(en)", -1))
const _hoisted_21 = ["src"]

import { completionTwoStore } from '@/stores/completionTwo'
import { ref } from 'vue'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import { WarningTwoTone, CheckOutlined, DownOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { generalStore } from '@/stores/general'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion2OptionsGrid',
  setup(__props) {

const showOptionDetailsModal = ref(false)
const currentOption = ref<{ id:number, externalRef:string, name:string, textSales:string, allImages:string[] }|null>(null)

function checkIfBottomBorder (layoutCount:number, layoutIndex:number) : string {
  const itemsOnBottomRow = layoutCount % 4

  if (layoutCount <= 4) {
    return 'no-border-bottom'
  } else if (layoutIndex > (layoutCount - itemsOnBottomRow)) {
    return 'no-border-bottom'
  }

  return ''
}

function toggleOptionDetailsModal (option:{ id:number, externalRef:string, name:string, textSales:string, allImages:string[] }|null = null) : void {
  showOptionDetailsModal.value = !showOptionDetailsModal.value
  currentOption.value = option
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          (_unref(completionTwoStore)().subelements.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(completionTwoStore)().subelements, (subelement, subelementIndex) => {
                return (_openBlock(), _createBlock(_component_a_collapse, {
                  class: "completion2-collapse",
                  key: subelementIndex + '-' + subelement.id
                }, {
                  expandIcon: _withCtx(({ isActive }) => [
                    (subelement.selected_option && subelement.selected_option.id)
                      ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                          key: 0,
                          style: {"color":"green"}
                        }))
                      : (_openBlock(), _createBlock(_unref(DownOutlined), {
                          key: 1,
                          rotate: isActive ? 180 : 0
                        }, null, 8, ["rotate"]))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, {
                      class: _normalizeClass(subelement.selected_option && subelement.selected_option.id ? 'panel-no-padding completed' : 'panel-no-padding incomplete')
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("b", _hoisted_1, _toDisplayString(subelement.name), 1)
                      ]),
                      extra: _withCtx(() => [
                        (_unref(completionTwoStore)().loading.options.includes(subelement.id) || _unref(completionTwoStore)().loading.selectedOption.includes(subelement.id))
                          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                              key: 0,
                              style: {"color":"#f38929"}
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(subelement.selected_option && subelement.selected_option.id && _unref(generalStore)().desktop ? 'Gekozen: ' + subelement.selected_option.name : ''), 1))
                      ]),
                      default: _withCtx(() => [
                        (subelement.options && subelement.options.length && !_unref(completionTwoStore)().loading.options.includes(subelement.id) && !_unref(completionTwoStore)().loading.selectedOption.includes(subelement.id))
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                (subelement.disabled)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      span: 24,
                                      style: {"padding":"16px","border-bottom":"1px solid #d9d9d9"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Onderstaande opties zijn niet meer te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_row, { style: {"margin-bottom":"0"} }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subelement.options, (option, optionIndex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass((_unref(generalStore)().desktop ? 'completion2-option-grid-item ' : 'completion2-option-grid-item-mobile ') + checkIfBottomBorder(subelement.options.length, optionIndex + 1)),
                                            key: option.id
                                          }, [
                                            _createElementVNode("div", _hoisted_3, [
                                              _createElementVNode("div", null, [
                                                (option.default)
                                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                                      key: 0,
                                                      color: "#f38929",
                                                      style: _normalizeStyle(_unref(generalStore)().desktop ? { position: 'absolute', margin: '150px 0 0 8px' } : { position: 'absolute', margin: '70px 0 0 8px' })
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Standaard")
                                                      ]),
                                                      _: 1
                                                    }, 8, ["style"]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("img", {
                                                  src: option.mainImage ? option.mainImage.url : '/img/No_Image.png',
                                                  style: _normalizeStyle({ maxWidth: '100%', maxHeight: _unref(generalStore)().desktop ? '180px' : '100px' })
                                                }, null, 12, _hoisted_4)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_5, [
                                              _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("p", null, [
                                                  _createTextVNode(_toDisplayString(option.name) + " ", 1),
                                                  (option.excluded_from_warranty)
                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(WarningTwoTone), {
                                                            "two-tone-color": "#f38929",
                                                            style: {"margin-left":"4px"}
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("p", _hoisted_7, "Optie nr. " + _toDisplayString(option.externalRef), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("p", {
                                                  style: {"color":"#f38929","cursor":"pointer"},
                                                  onClick: ($event: any) => (toggleOptionDetailsModal(option))
                                                }, "Meer informatie", 8, _hoisted_9)
                                              ]),
                                              _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, [
                                                  (subelement.selected_option && subelement.selected_option.id === option.id)
                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                        key: 0,
                                                        type: "primary",
                                                        class: "option-btn",
                                                        disabled: _unref(authStore)().restricted() || _unref(completionTwoStore)().saving.subelementId !== 0 || _unref(completionTwoStore)().phaseIsClosed || subelement.disabled
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Gekozen")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["disabled"]))
                                                    : (_openBlock(), _createBlock(_component_a_button, {
                                                        key: 1,
                                                        loading: _unref(completionTwoStore)().saving.subelementId === subelement.id && _unref(completionTwoStore)().saving.optionId === option.id,
                                                        disabled: _unref(authStore)().restricted() || _unref(completionTwoStore)().saving.subelementId !== 0 || _unref(completionTwoStore)().phaseIsClosed || subelement.disabled,
                                                        onClick: ($event: any) => (_unref(completionTwoStore)().selectOption(subelement, subelementIndex, option))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(!_unref(completionTwoStore)().phaseIsClosed ? 'Kies' : 'Niet gekozen'), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["loading", "disabled", "onClick"]))
                                                ]),
                                                _createElementVNode("div", _hoisted_12, [
                                                  _createElementVNode("p", _hoisted_13, "€ " + _toDisplayString(option.price), 1),
                                                  _createElementVNode("p", _hoisted_14, "incl. " + _toDisplayString(option.vat_rate) + "% BTW", 1)
                                                ])
                                              ])
                                            ])
                                          ], 2))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : (_unref(completionTwoStore)().loading.options.includes(subelement.id)|| _unref(completionTwoStore)().loading.selectedOption.includes(subelement.id))
                            ? (_openBlock(), _createBlock(_component_a_row, {
                                key: 1,
                                style: {"margin-bottom":"0","padding":"16px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_skeleton, { active: "" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_a_row, {
                                key: 2,
                                style: {"margin-bottom":"0","padding":"16px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _hoisted_15,
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : (_openBlock(), _createBlock(_component_a_skeleton, {
                key: 1,
                active: ""
              })),
          (currentOption.value)
            ? (_openBlock(), _createBlock(_component_a_modal, {
                key: 2,
                width: 600,
                footer: false,
                visible: showOptionDetailsModal.value,
                onCancel: _cache[0] || (_cache[0] = ($event: any) => (toggleOptionDetailsModal()))
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentOption.value.externalRef) + " - " + _toDisplayString(currentOption.value.name), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(currentOption.value.externalRef) + " - " + _toDisplayString(currentOption.value.name) + " ", 1),
                            (currentOption.value.excluded_from_warranty)
                              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                  title: _withCtx(() => [
                                    _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_unref(WarningTwoTone), {
                                      "two-tone-color": "#f38929",
                                      style: {"margin-left":"4px"}
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (currentOption.value.textSales)
                    ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _createElementVNode("div", {
                                innerHTML: currentOption.value.textSales
                              }, null, 8, _hoisted_19)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (currentOption.value.allImages.length)
                    ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createVNode(_unref(Carousel), { "wrap-around": true }, {
                                addons: _withCtx(() => [
                                  (currentOption.value.allImages.length > 1)
                                    ? (_openBlock(), _createBlock(_unref(Navigation), { key: 0 }))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOption.value.allImages, (image) => {
                                    return (_openBlock(), _createBlock(_unref(Slide), { key: image }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: image.url,
                                          height: "400"
                                        }, null, 8, _hoisted_21)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["visible"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})